module.exports = __webpack_public_path__ + "static/media/next-big-future.bf04a3ff.jpg";